"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _decorators = require("decorators");

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _ProfileImageContainer = babelHelpers.interopRequireDefault(require("components/ProfileImageContainer"));

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _temp;

var Node = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Node, _Component);

  function Node() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, Node);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Node)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "node", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "footer", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "collapsed", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "image", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "expand", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "menu", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "discussion", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "isAbuseReport", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "className", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    _this.state = {
      dropdownOpen: false
    };
    return _this;
  }

  babelHelpers.createClass(Node, [{
    key: "expose",
    value: function expose() {
      if (this.collapsed) this.expand();
    }
  }, {
    key: "getMenu",
    value: function getMenu() {
      if (this.discussion.state.discussion.node.report) {
        return this.menu.concat(this.isAbuseReport ? [] : [{
          title: 'Report',
          invoke: this.doReport
        }]);
      }

      return this.menu;
    }
  }, {
    key: "doReport",
    value: function doReport(event) {
      if (event) event.preventDefault();
      this.discussion.leaveReportResponse(null, this.node.id);
    }
  }, {
    key: "showDropdown",
    value: function showDropdown(event) {
      var _this2 = this;

      this.setState(function (st) {
        return {
          dropdownOpen: !_this2.state.dropdownOpen
        };
      });
      event.stopPropagation();
    }
  }, {
    key: "handleDropdownClick",
    value: function handleDropdownClick(event) {
      this.getMenu()[event.target.dataset.index].invoke();
      this.setState({
        dropdownOpen: false
      });
    }
  }, {
    key: "handleBodyClick",
    value: function handleBodyClick(event) {
      if (this.state.dropdownOpen) {
        this.setState({
          dropdownOpen: false
        }); // event.stopPropagation();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.dropdownOpen) {
        document.documentElement.addEventListener('click', this.handleBodyClick);
      } else {
        document.documentElement.removeEventListener('click', this.handleBodyClick);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.dropdownOpen) {
        document.documentElement.removeEventListener('click', this.handleBodyClick);
      }
    }
  }, {
    key: "formatDate",
    value: function formatDate(d) {
      var now = Date.now();

      if (d.getTime() > now - 60000) {
        return 'now';
      }

      if (d.getTime() > now - 3600000) {
        var minutes = (now - d.getTime()) / 60000;
        minutes = Math.round(minutes);
        return "".concat(minutes, " minute").concat(minutes == 1 ? '' : 's', " ago");
      }

      if (d.getTime() > now - 86400000) {
        var hours = (now - d.getTime()) / 3600000;
        hours = Math.floor(hours);
        return "".concat(hours, " hour").concat(hours == 1 ? '' : 's', " ago");
      }

      if (d.getTime() > now - 7 * 86400000) {
        var days = (now - d.getTime()) / 86400000;
        days = Math.floor(days);
        return "".concat(days, " day").concat(days == 1 ? '' : 's', " ago");
      }

      if (d.getTime() > now - 365 * 86400000) {
        return d.format('M j');
      }

      return d.format('M j, Y');
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      if (this.node) {
        return _react.default.createElement("article", {
          id: "comment-".concat(this.node.id),
          className: _classList.default.join('comment-item', this.collapsed ? 'collapsed' : '', this.isAbuseReport ? 'abuse-report' : '', this.className)
        }, _react.default.createElement("header", {
          onClick: this.expose,
          style: {
            cursor: this.collapsed ? 'pointer' : ''
          }
        }, this.collapsed && this.image ? _react.default.createElement("div", {
          className: "itemImage",
          style: {
            backgroundImage: "url(".concat(this.image, ")")
          }
        }) : null, _react.default.createElement("div", {
          className: "photo"
        }, _react.default.createElement(_ProfileImageContainer.default, {
          className: "userProfilePhoto",
          noImageClassName: "initials default",
          image: this.node.account ? this.node.account.photo : null,
          name: this.node.account ? this.node.account.fullName : ""
        })), _react.default.createElement("div", {
          className: "info-block"
        }, _react.default.createElement("div", {
          className: "person"
        }, _react.default.createElement("span", {
          className: "person-name"
        }, this.node.account ? this.node.account.fullName : 'System', this.node.account.icons && this.node.account.icons.length > 0 && _react.default.createElement("span", {
          className: "account-icon-list"
        }, this.node.account.icons.map(function (_ref, index) {
          var title = _ref.title,
              icon = _ref.icon;
          return _react.default.createElement("img", {
            key: index,
            title: title,
            src: icon,
            className: "account-icon"
          });
        }))), this.node.account && this.node.account.personTitle ? _react.default.createElement("span", {
          className: "person-title"
        }, this.node.account.personTitle) : null, this.node.account && this.node.account.location ? _react.default.createElement("span", {
          className: "person-location"
        }, this.node.account.location) : null), _react.default.createElement("div", {
          className: "comment-time"
        }, _react.default.createElement("time", {
          dateTime: this.node.created
        }, this.formatDate(new Date(this.node.created))))), !this.collapsed ? _react.default.createElement("div", {
          className: _classList.default.join('dropdown', this.state.dropdownOpen ? 'open' : '')
        }, _react.default.createElement("a", {
          style: {
            visibility: this.getMenu().length ? 'visible' : 'hidden'
          },
          onClick: this.showDropdown,
          href: "javascript:void(0)",
          className: "options"
        }), this.getMenu().length ? _react.default.createElement("ul", {
          className: "dropdown-menu dropdown-menu-right"
        }, this.getMenu().map(function (item, index) {
          return _react.default.createElement("li", {
            key: index
          }, _react.default.createElement("a", {
            onClick: _this3.handleDropdownClick,
            "data-index": index
          }, item.title));
        })) : null) : null), this.collapsed ? null : this.props.children, this.collapsed ? null : this.footer);
      }

      return null;
    }
  }]);
  return Node;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "node", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "footer", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "collapsed", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "image", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "expand", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "menu", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "discussion", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "isAbuseReport", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "expose", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "expose"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "doReport", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "doReport"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "showDropdown", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "showDropdown"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "handleDropdownClick", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleDropdownClick"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "handleBodyClick", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "handleBodyClick"), _class.prototype)), _class);
exports.default = Node;